import { footerData } from '@/mocks/homeData';

export default function Footer() {
  return (
    <footer id="footer" className="bg-background-100 border-t border-background-200/60">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="mx-auto max-w-[1280px]">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-10 mb-10">
            <div>
              <a href="#hero" className="inline-block text-xl font-heading font-bold text-primary-500 mb-4 no-underline">
                韩国漫画
              </a>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {footerData.description}
              </p>
            </div>

            {footerData.sections.map((section) => (
              <div key={section.title}>
                <h4 className="text-sm font-semibold text-foreground-800 mb-4">
                  {section.title}
                </h4>
                <ul className="space-y-2.5">
                  {section.links.map((link) => (
                    <li key={link.label}>
                      <a
                        href={link.href}
                        className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200 no-underline"
                      >
                        {link.label}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          <div className="border-t border-background-200/60 pt-8">
            <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
              <p className="text-xs text-foreground-500">
                &copy; {new Date().getFullYear()} 韩国漫画网 — 高清韩国漫画在线免费阅读平台
              </p>
              <div className="flex items-center gap-5">
                <span className="text-xs text-foreground-400">合作伙伴</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}